import Vue from "vue";

Vue.component("unofficial-translation", {
	props: ["notificationId", "symbol"],
	data() {
		return {
			loading: false,
			requesLoading: false,
			showDetails: false,
			showMaintenanceModal: false,
			validationMessage: '',
			measures: []
		};
	},
	computed: {
		requestForUnofficialTranslationLabel() {
			return window.labels.requestForUnofficialTranslation;
		},
		closeLabel() {
			return window.labels.closeText;
		},
		loadingText() {
			return window.labels.loading;
		},
		processingText() {
			return window.labels.processing;
		},
		maintenanceText() {
			return 'Unofficial Translation Maintenance';
		},
		currentLanguageInt() {
			return window.currentLanguageInt;
		},
		isMaintenance() {
			return window.unofficialTranslationMaintenance;
		}
	},
	methods: {
		modalOpen: function () {
			console.log(this.isMaintenance)
			if (this.isMaintenance) {
				this.showMaintenanceModal = true;
			} else {
				this.showDetails = true;
			}
		},
		getCRNAttachmentForUnofficialTranslation: function () {
			this.loading = true;
			this.$services.notifications.getCRNAttachmentForUnofficialTranslation({
				notificationId: this.notificationId,
				language: window.currentOfficialLanguageInt
			})
				.then((data) => {
					this.loading = false;
					this.measures = data;
				});
		},
		getTranslationFileValidationMessage: function () {
			this.$services.staticContents.getContent({
				code: 'unofficial-translation-filesize-validation',
				language: window.currentLanguageInt
			})
			.then((data) => {
				this.validationMessage = this.removeTags(data.content);
			});
		},	
		requestForUnofficialTranslation: function (model, language) {
			model.isProcessing = true;
			this.$services.unofficialTranslations.requestTranslation({
				notificationId: this.notificationId,
				crnAttachment: model.crnAttachment,
				language: language
			})
				.then((response) => {
					if (response.data.isSuccess) {
						this.$buefy.toast.open({
							duration: 5000,
							message: response.data.message,
							position: 'is-top-right',
							type: 'is-success'
						});
					}
					else {
						this.$buefy.toast.open({
							duration: 5000,
							message: response.data.message,
							position: 'is-top-right',
							type: 'is-danger'
						});
					}	

					model.isProcessing = false;
				});
		},
		removeTags: function (value) {
			if (!value) return "";

			const txt = document.createElement('textarea');
			txt.innerHTML = value;
			let returnValue = txt.value.replace(/(<([^>]+)>)/ig, '');
			returnValue = returnValue.replace('&nbsp;', '');
			return returnValue;
		},
	},
	mounted() {
		this.getCRNAttachmentForUnofficialTranslation();
		this.getTranslationFileValidationMessage();
	},
	template: `
      <div class="unofficial-translation-container" v-if="measures && measures.length > 0">
		<b-tooltip :label="requestForUnofficialTranslationLabel" type="is-primary is-light" position="is-bottom" size="is-small" multilined>
			<b-button @click="modalOpen"><b-icon icon="language" size="is-medium"></b-icon></b-button>
		</b-tooltip>
      	<b-modal v-model="showDetails" #default="props" class="measures-modal">
			<div class="modal-card" style="width: 100% !important;">
				<header class="modal-card-head" style="flex-direction: column;align-items: start;">
					<h3 class="title-notification">
						<p class="modal-card-title truncate-overflow-1" :title="symbol">{{ symbol }}</p>
					</h3>
					<div class="modal-card-title">{{ requestForUnofficialTranslationLabel }}</div>
				</header>
				<section class="modal-card-body">
					<div v-if="loading">
						<loading :loading-text="loadingText"></loading>
					</div>
					<div v-else>
						<div style="margin-bottom: 10px">
							<b-table :data="measures" :striped="true" :hoverable="true">
								<b-table-column field="link" label="Measure" width="40%" v-slot="props">
									<div v-html="props.row.link"></div>
								</b-table-column>
								<b-table-column field="languages" label="Unofficial Translation"  v-slot="props">
									<div v-if="props.row.isProcessing">
										<loading :loading-text="processingText"></loading>
									</div>
									<div v-else>
										<div v-if="props.row.canTranslate">
											<div style="display:flex;flex-direction: row;align-items: start;gap:10px">
												<div v-for="language in props.row.languages" :key="language">
													<a @click="requestForUnofficialTranslation(props.row, language)">{{ language }}</a>
												</div>
											</div>
										</div>
										<div v-else>
											 <b-tooltip class="search-product-free-text unofficial-tooptip" :label="validationMessage" type="is-primary is-light" position="is-right" size="is-large" multilined>
												<b-icon pack="far" icon="info-circle" size="is-small"></b-icon>
											</b-tooltip>
										</div>
									</div>
								</b-table-column>
							</b-table>
						</div>
						<div class="unofficial-translation-disclaimer">
						<static-content :code="'notification-unofficial-translation-disclaimer'" :language="currentLanguageInt"></static-content>
						</div>
					</div>					
				</section>
				<footer class="modal-card-foot buttons is-right">
					<b-button :label="closeLabel" @click="props.close"></b-button>
				</footer>
			</div>
		</b-modal>
		<b-modal v-model="showMaintenanceModal" :can-cancel="true" #default="props">
			<div class="modal-card" style="width: 100% !important">
				<header class="modal-card-head">
					{{ maintenanceText }}
				</header>
				<section class="static modal-card-body">
					<static-content :code="'unofficial-translation-maintenance'" :language="currentLanguageInt"></static-content>
				</section>
				<footer class="modal-card-foot buttons is-right">
					<b-button :label="closeLabel" @click="props.close"></b-button>
				</footer>
			</div>
		</b-modal>
	  </div>
	`,
});